var exports = {
  "Qs": "KeyboardShortcutsCheatsheetModal.module__content___bVpUal",
  "V0": "KeyboardShortcutsCheatsheetModal.module__sections___bVpUal",
  "uW": "KeyboardShortcutsCheatsheetModal.module__section___bVpUal",
  "Gf": "KeyboardShortcutsCheatsheetModal.module__sectionTitle___bVpUal",
  "wE": "KeyboardShortcutsCheatsheetModal.module__shortcutRows___bVpUal",
  "J8": "KeyboardShortcutsCheatsheetModal.module__shortcutRow___bVpUal",
  "hV": "KeyboardShortcutsCheatsheetModal.module__shortcutLabel___bVpUal",
  "PU": "KeyboardShortcutsCheatsheetModal.module__chipGroups___bVpUal",
  "al": "KeyboardShortcutsCheatsheetModal.module__chipGroup___bVpUal",
  "jw": "KeyboardShortcutsCheatsheetModal.module__chip___bVpUal",
};

module.exports = exports;
